/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewChecked, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Breadcrumb } from 'app/core/services/breadcrumb/breadcrumb.interface';
import { BreadcrumbService } from 'app/core/services/breadcrumb/breadcrumb.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { MapsService } from '../maps.service';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';

@Component({
  selector: 'app-map-layout',
  templateUrl: './map-layout.component.html',
  styleUrls: ['./map-layout.component.scss'],
  encapsulation:  ViewEncapsulation.None
})
export class MapLayoutComponent implements OnInit, AfterViewChecked {

  sidebar: boolean = true;
  render_element: boolean = true;
  map_view: any = {};

  breadcrumbData: Breadcrumb = {
    'moduleName': 'maps',
    'displayKey': "text.maps",
    'moduleKey': 'MAPS',
    'redirectTo': '/maps',
    'breadcrumbItems': [],

};

  constructor(
    private _breadcrumbService: BreadcrumbService,
    private _MapService: MapsService,
    private title: Title,
    private utilityService: UtilityService,
    private _analytics: AnalyticsService
  ) {
    this._breadcrumbService.count = '';
   }

  toggleSidebar(): void{
    if(this.sidebar === false){
      this.sidebar = !this.sidebar;
      this._MapService.sidebar.next(this.sidebar);

      setTimeout(()=>{
        this.render_element = !this.render_element;
      },200);
    }else{
      this.sidebar = !this.sidebar;
      this.render_element = !this.render_element;
      this._MapService.sidebar.next(this.sidebar);
    }
  }

  setMapView(event: any): void{
    this.map_view = event;
  }


  ngOnInit(): void {
    const routeState = window.history.state;
    if(routeState?.event){
      this._analytics.trackEvent(routeState?.event);
    }
    this._breadcrumbService.count = '';
    this._breadcrumbService.subject.next(this.breadcrumbData);
  }

  ngAfterViewChecked(): void {
    this.title.setTitle(this.utilityService.getLocaleValue('zuper.title.maps','Zuper Pro - Maps'));
  }

}
